'use strict';

//libraries
var React = require('react');
var Products = require('../../utils/Products.js');

//yourDetails
var YourDetailsActions = require('../../actions/YourDetailsActions.js');

//Common components
var TelephoneNumbers = require('../Common/TelephoneNumbers.jsx');
var Email = require('../Common/Email.jsx');

var ContactDetails = React.createClass({
    propTypes: {
        errorList: React.PropTypes.array,
        data: React.PropTypes.object,
        index: React.PropTypes.number,
        section: React.PropTypes.string,
        isBusiness: React.PropTypes.bool
    },
    getDefaultProps: function () {
        return {
            errorList: [],
            isBusiness: false
        };
    },
    updateYourDetailsData: function(event){
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value, this.props.index);
    },
    render: function () {
        return (
                <div>
                    <TelephoneNumbers id={this.props.productId + this.props.accountType}
                                    index={this.props.index}
                                    productId={this.props.productId}
                                    mobileNumber={this.props.data.mobileNumber}
                                    homeNumber={this.props.data.homeNumber}
                                    workNumber={this.props.data.workNumber}
                                    mobileNumberReadonly={this.props.data.mobileNumberReadonly}
                                    homeNumberReadonly={this.props.data.homeNumberReadonly}
                                    workNumberReadonly={this.props.data.workNumberReadonly}
                                    onContactDetailsChange={this.updateYourDetailsData}
                                    section={this.props.section}
                                    isBusiness={this.props.isBusiness}
                                    errorList={this.props.errorList}/>
                    <Email  index={this.props.index}
                            productId={this.props.productId}
                            value={this.props.data.emailAddress}
                            onEmailChange={this.updateYourDetailsData}
                            section={this.props.section}
                            errorList={this.props.errorList}
                            isBusiness={this.props.isBusiness}
                            hideWhyWeAskText={Products.isAnnuity(this.props.productId)} 
                            readonly={this.props.data.emailAddressReadonly}
                            mandatory={true} />
                </div>
            );
    }
});

module.exports = ContactDetails;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/ContactDetails.jsx